import { Component, Input, OnInit } from '@angular/core';

import { IColunaTextoIcone } from '../../interface/icm-texto-icone-generico';

@Component({
    selector: 'icm-coluna-texto-icone',
    templateUrl: './view/icm-coluna-texto-icone.component.html',
    styleUrls: ['./view/icm-coluna-texto-icone.component.scss'],
})
export class IcmColunaTextoIconeComponent implements OnInit {
    @Input() linha;
    @Input() coluna: IColunaTextoIcone;
    @Input() carregando: boolean;

    texto: string | number | Date;
    icone: string;
    textoTooltip: string;
    corTexto: string = '#000000de';
    corIcone: string = '#000000de';
    corDesabilitado: string = '#00000042';

    constructor() {}

    ngOnInit(): void {
        this.inicializarValores();
    }

    inicializarValores() {
        this.texto = this.coluna.valor(this.linha);
        this.icone = this.coluna.icone.valor(this.linha);
        this.textoTooltip = this.coluna.icone.tooltip.valor(this.linha);
        if (this.coluna?.cor) this.corTexto = this.coluna.cor(this.linha);
        if (this.coluna.icone?.cor) this.corIcone = this.coluna.icone.cor(this.linha);
    }
}
